export class ReturnRevisionDataModel {
  reason: string;
  value: number;
}
